export const linkedToTypes = {
  PARTNER: 'PARTNER',
  OPERATION: 'OPERATION',
};
